module.exports = __webpack_public_path__ + "img/threeOrange.dd4ae865.jpg";